import React from 'react';
import { Typography, Box, Grid, useTheme,Link } from '@mui/material';
import Footer from './footer';

function Home() {
  const theme = useTheme();
  const text2color = theme.palette.mode === 'dark' ? '#FFC300' : '#ffffff';
  const text1color = theme.palette.mode === 'dark' ? '#26E113 ' : '#26E113 ';

  return (
    <Box
      sx={{
        display: 'flex',
        p: 2,
        backgroundImage: 'url("/images/home.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        marginTop="40px"
        sx={{
          width: '100%',
          padding: '1rem',
          '@media (min-width: 960px)': { 
            width: '50%', 
          },
        }}
      >
        <div>
          <Typography variant="h6" gutterBottom sx={{ color: text2color,textDecoration: 'underline',fontSize:"24px", fontStyle:"Apple Color Emoji" }}>
            <b>Welcome to My Portfolio,</b>
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ color: text2color,fontSize:"18px" }}>
            Hi, I'm <b>Eng. EVERLYNE AKINYI</b>, a passionate software engineer with a strong interest in web development and responsive ui/ux design.
            This is my portfolio, where I showcase some of the projects I have worked on and my skills in various technologies.
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ color: text2color, fontStyle:'italic' }}>
            Feel free to explore the different sections to learn more about me and my work.
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ color: text2color }}>
          You can download my CV <Link href="/images/EVERLYNE REVISED_Cv.pdf" download sx={{color:text1color}}>here</Link>.
         </Typography>
        </div>
        <Footer />
      </Grid>
    </Box>
  );
}

export default Home;
